import React from "react";
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import {
    amountDataTableTemplate,
    numberWithCommaDataTableTemplate, numberWithoutCommaDataTableTemplate,
    priceDataTableTemplate
} from "../../../utils/formatters/Numbers";
import {Dialog} from "primereact/dialog";
import {InputTextarea} from "primereact/inputtextarea";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";
import LoadingOverlay from 'react-loading-overlay';

const MoveTitleGuarantee = ({...props}) => {
    return (
        <React.Fragment>
            <LoadingOverlay
                active={props.isLoading}
                spinner
                text='Loading...'>
                <Paper elevation={5}
                       style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                    {props.messagesGrowl}
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <TitlePage title={"Tablero de Control \\ " + props.action}/>
                        </Grid>
                        <Grid item xs={6}>
                            <Grid item>
                                <Button
                                    label="Aceptar"
                                    style={{'float': 'right'}}
                                    onClick={props.handleAgree}/>
                            </Grid>
                            {
                                (props.status !== 'V' && props.status !== 'VA') &&

                                <Grid item>
                                    <Button
                                        label="Rechazar"
                                        style={{'float': 'right'}}
                                        className="p-button-secondary"
                                        onClick={props.showRejectDialog}/>
                                </Grid>
                            }
                            <Grid item>
                                <Button
                                    label="Regresar"
                                    style={{'float': 'right'}}
                                    className="p-button-secondary"
                                    onClick={props.handleReturnButton}/>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Divider/>
                        </Grid>
                        <Grid item xs={12}>
                            <TitlePage title="Préstamo"/>
                        </Grid>
                        <Grid item xs={12}>
                            <DataTable
                                value={props.loan}
                                resizableColumns={true}
                                columnResizeMode={"fit"}>
                                {
                                    props.readOnlyTitles ?
                                        <Column field="folioIndeval" header="Folio Traspaso"
                                                style={{textAlign: 'left'}} sortable={true} body={numberWithoutCommaDataTableTemplate}/> :
                                        <Column field="folioIndeval" header="Folio Traspaso"
                                                style={{textAlign: 'left'}} body={numberWithoutCommaDataTableTemplate}
                                                editor={props.titleEditor} sortable={true}/>
                                }
                                <Column field="folioPrestamo" header="Folio"
                                        style={{textAlign: 'right'}} sortable={true}/>
                                <Column field="emisora" header="Emisora"
                                        style={{textAlign: 'left'}} sortable={true}/>
                                <Column field="cantidadTitulos" header="Títulos"
                                        body={numberWithCommaDataTableTemplate}
                                        style={{textAlign: 'right'}} sortable={true}/>
                                <Column field="precio" header="Precio"
                                        body={priceDataTableTemplate}
                                        style={{textAlign: 'right'}} sortable={true}/>
                            </DataTable>
                        </Grid>
                        {props.hideReward &&
                            <Grid item xs={12}>
                                <Grid item xs={12}>
                                    <Divider/>
                                </Grid>
                                < Grid item xs={12}>
                                    <SubtitleLabel header="Premio" isBold={true}/>
                                </Grid>
                                <Grid item xs={12}>
                                    <DataTable
                                        value={props.loan}
                                        resizableColumns={true}
                                        columnResizeMode={"fit"}>
                                        {
                                            props.readOnlyReward ?
                                                <Column field="folioPremio" header="Folio Premio"
                                                        style={{textAlign: 'left'}} sortable={true} body={numberWithoutCommaDataTableTemplate}/> :
                                                <Column field="folioPremio" header="Folio Premio"
                                                        style={{textAlign: 'left'}}
                                                        editor={props.rewardEditor} sortable={true} body={numberWithoutCommaDataTableTemplate}/>
                                        }
                                        <Column
                                            field="premio"
                                            header="Premio"
                                            body={amountDataTableTemplate}
                                            sortable={true}/>
                                    </DataTable>
                                </Grid>
                            </Grid>
                        }
                        <Grid item xs={12}>
                            <Divider/>
                        </Grid>
                        <Grid item xs={12}>
                            {(props.status === "TP" || props.status === "CoTP") &&
                                <SubtitleLabel header="Traspaso de Premio" isBold={true}/>
                            }
                            {!(props.status === "TP" || props.status === "CoTP") &&
                                <SubtitleLabel header="Deposito en INDEVAL" isBold={true}/>
                            }
                        </Grid>
                        <Grid item xs={12}>
                            {(props.status !== "TP" && props.status !== "CoTP") &&
                                <SubtitleLabel header={"Cuenta Valores Origen - " + props.indevalAccount[3]}
                                               isBold={false}/>
                            }
                            {(props.status !== "TP" && props.status !== "CoTP") &&
                                < SubtitleLabel header={"Cuenta Valores Destino - " + props.indevalAccount[5]}
                                                isBold={false}/>
                            }
                            <SubtitleLabel header={"Cuenta Efectivo Origen - " + props.indevalAccount[4]}
                                           isBold={false}/>
                            <SubtitleLabel header={"Cuenta Efectivo Destino - " + props.indevalAccount[6]}
                                           isBold={false}/>
                        </Grid>
                        <Grid item xs={12}>
                            <Divider/>
                        </Grid>
                        <Grid item xs={12}>
                            <SubtitleLabel header="Garantías" isBold={true}/>
                        </Grid>
                        <Grid item xs={12}>
                            <DataTable
                                value={props.guaranteeInFlow}
                                resizableColumns={true}
                                columnResizeMode={"fit"}>
                                {
                                    props.readOnlyGuarantee ?
                                        <Column field="folioGarantia" header="Folio Traspaso"
                                                style={{textAlign: 'left'}} sortable={true} body={numberWithoutCommaDataTableTemplate}/> :
                                        <Column field="folioGarantia" header="Folio Traspaso"
                                                style={{textAlign: 'left'}}
                                                editor={props.guaranteeEditor} sortable={true} body={numberWithoutCommaDataTableTemplate}/>

                                }
                                <Column field="emisora" header="Emisora"
                                        style={{textAlign: 'left'}} sortable={true}/>
                                <Column field="titulos" header="Títulos"
                                        body={numberWithCommaDataTableTemplate}
                                        style={{textAlign: 'right'}} sortable={true}/>
                                <Column field="precioMercado" header="Precio Mercado"
                                        body={priceDataTableTemplate}
                                        style={{textAlign: 'right'}} sortable={true}/>
                            </DataTable>
                        </Grid>
                    </Grid>
                </Paper>
            </LoadingOverlay>

            <Dialog visible={props.displayDialog} header={props.dialogHeader} modal={true}
                    onHide={props.onHideDialog} closable={false} style={{width: "45%"}}>
                <div className="p-grid p-fluid">
                    <div className="p-col-12">
                        <SubtitleLabel header="Indique el motivo de rechazo" isBold={true}/>
                        <InputTextarea name="rejectMessage" rows={5} cols={30} autoResize={true}
                                       value={props.rejectMessage} onChange={props.saveMessage}/>
                    </div>
                </div>
            </Dialog>
        </React.Fragment>
    )
};

export default MoveTitleGuarantee;